



























































































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

import {
  getSpeaker,
  createSpeaker,
  updateSpeaker,
} from '@/api/index';

import useAxios from '@/useAxios';

const PanelWithSpeakerEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonDropzoneWithAxios,
  },
  props: {
    edit: { default() { return false; } },
  },
  setup(props: any) {
    const { route } = useRouter();
    const { axios } = useAxios();

    const successModal = ref(null);
    const loading = ref(true);

    const form = reactive({
      name: '',
      nameEN: '',
      position: '',
      positionEN: '',
      workplace: '',
      workplaceEN: '',
      description: '',
      descriptionEN: '',
      avatarUrl: '',
      isMarkdown: 'false',

      facebook: '',
      twitter: '',
      instagram: '',
      telephone: '',
      email: '',

      call: async () => {
        /* eslint-disable */
        if (props.edit === true) {
          await updateSpeaker(route.value.params.id, {
            name: form.name,
            name_en: form.nameEN,
            position: form.position,
            position_en: form.positionEN,
            workplace: form.workplace,
            workplace_en: form.workplaceEN,
            description: form.description,
            description_en: form.descriptionEN,
            is_markdown: form.isMarkdown === 'true' ? true : false,
            avatar_url: form.avatarUrl,
            facebook: form.facebook,
            twitter: form.twitter,
            instagram: form.instagram,
            telephone: form.telephone,
            email: form.email,
          });
        } else {
          await createSpeaker({
            name: form.name,
            name_en: form.nameEN,
            position: form.position,
            position_en: form.positionEN,
            workplace: form.workplace,
            workplace_en: form.workplaceEN,
            description: form.description,
            description_en: form.descriptionEN,
            is_markdown: form.isMarkdown === 'true' ? true : false,
            avatar_url: form.avatarUrl,
            facebook: form.facebook,
            twitter: form.twitter,
            instagram: form.instagram,
            telephone: form.telephone,
            email: form.email,
          });
        }
        /* eslint-enable */
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
      state: {
        value: 'READY',
      },
    });

    const _avatarPath = computed(() => {
      const isUrlAbsolute = (url: string) => (url.indexOf('://') > 0 || url.indexOf('//') === 0);
      if (form.avatarUrl === null || !(isUrlAbsolute(form.avatarUrl))) {
        return '/avatar.png';
      }
      return form.avatarUrl;
    });

    onMounted(async () => {
      if (props.edit === true) {
        const result = await getSpeaker(route.value.params.id);
        form.name = result.name;
        form.nameEN = result.name_en;
        form.position = result.position;
        form.positionEN = result.position_en;
        form.workplace = result.workplace;
        form.workplaceEN = result.workplace_en;
        form.description = result.description;
        form.descriptionEN = result.description_en;
        form.isMarkdown = result.is_markdown === 1 ? 'true' : 'false';
        form.avatarUrl = result.avatar_url;
        form.facebook = result.facebook;
        form.twitter = result.twitter;
        form.instagram = result.instagram;
        form.telephone = result.telephone;
        form.email = result.email;
      }
      loading.value = false;
    });

    function handleUploadDone(data: any) {
      if (props.edit) form.avatarUrl = data.data.speaker.avatar_url;
      else form.avatarUrl = data.data.path;
    }

    return {
      telephoneValidationRules: { regex: /^((\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}|(\+(\d{11})))$/ },

      successModal,

      form,
      _avatarPath,

      axios,
      handleUploadDone,
    };
  },
});

export default PanelWithSpeakerEditor;
